import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontProgress from './progress';
import api from '../apiConnector'

const pageToBranch = {'payment':'xena','payment2':'axa','payment3':'fma'}


export default class FrontPayment extends React.Component {
    
    constructor(props) {
        super(props);
        this.timer = false
    }

    periodic() {
        this.props.checkStatus()
    }

    componentDidMount() {
        this.timer = setInterval(
            this.periodic.bind(this),
            3000
        )
    }

    componentWillUnmount() {
        if ( this.timer ) {
            clearInterval( this.timer )
            this.timer = false
        }
    }

    toPay(c) {
        switch ( c.branch ) {
            case 'xena': return c.devis.toPay()
            case 'axa': return c.axa.fancyPrice( c.axa.frais )
            case 'fma': return c.fma.fancyPrice( c.fma.frais )
        }
        throw new Error(`Invalid branch ${c.branch}`)
    }


    render() {
        const {devis,page,setPage,changeParams} = this.props
        const params = devis.params
        const axa = devis.getAxa().setChoicesFromDevis().setFancy('-',' €')
        const fma = devis.getFma().setChoicesFromDevis().setFancy('-',' €')
        const branch = pageToBranch[page]
        if ( !branch ) throw new Error(`Invalid page for component FrontPayment : ${page}`) 
        const container = {
            devis:devis,
            changeParams:changeParams,
            setPage: setPage,
            axa:axa,
            fma:fma,
            branch:branch
        }

        const toPay = this.toPay(container)

        return <>
        <FrontProgress lastBranch={this.props.lastBranch || this.props.devis.tb} comparateursCompleted={true} setPage={setPage} page={page} topRef={this.props.topRef}/>
        <div className="container">

            <div className="contentbox">
                <div className="contentvbox">
                <h1 className="top_title">Procédez au paiement de l'acompte</h1>
                <p className="text centered">
                Le montant de l'acompte s'élève à <b>{toPay}</b>.
                </p>
                {this.props.embeded?
                <p className="text">
                    <span>En mode commercial : vous pouvez envoyer un lien de paiement au client : les documents seront envoyés automatiquement dès réception du paiement.</span>
                    <a className="button button_subscribe" onClick={this.props.sendPaymentLink}>
                        Envoyer un lien de paiement au client
                    </a>
                    <span>ou cliquez sur le bouton ci-dessous si le paiement a déjà été réalisé depuis une autre source que le paiement CB en ligne.</span>
                    <a className="button button_subscribe red" onClick={this.props.validatePayment}>
                        Souscrire sans paiement <span>▸</span>
                    </a>
                    <span>ou encore, entrer les données de carte bancaire vous même ci-dessous.</span>
                </p>:''}
                { params.paymentError ? <>
                <p>Le paiement a échoué&nbsp;:</p>
                <p className="error">
                    {params.paymentError}
                </p>
                <p>
                    <a className="button button_subscribe" onClick={()=>container.changeParams({paymentError:false})}>
                        Réessayer <span>▸</span>
                    </a>
                </p>
                </>:<iframe src={api.paymentUrl(this.props.devis.type+this.props.devis._id.$oid,branch)} name="paymentFrame"/>
                }
                </div>
            </div>
            <div className="contentbox_middle"/>

            <div className="contentbox contentbox_right">
                <FrontRecapitulatif api={api} devis={this.props.devis} container={container}/>

                <h1 className="subscribe">Contactez nous par téléphone</h1>
                <a href="tel:0974772861" className="tel">09 74 77 28 61</a>
            </div>

            </div>

        </>
    }
}